import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableConfig } from '../../../../../../../projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-extra-params';
import { ITableHeaderParams } from '../../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { LanguageService } from '../../../../../../../projects/common/src/app/services/parameters/language/language.service';
import { TableConfigService } from '../../../../../../../projects/common/src/app/services/table/table-config.service';
import { IReportMachineStatusResponse, IMachineStatusFamily } from '../../../interfaces/machine-status';

@Component({
  selector: 'app-status-family-table',
  templateUrl: './status-family-table.component.html',
  styleUrls: ['./status-family-table.component.scss'],
})
export class StatusFamilyTableComponent implements OnChanges, OnDestroy {
  @Input()
  public data: IReportMachineStatusResponse;

  public tableConfig: ITableConfig;
  public subSource: Subscription;

  constructor(private tableConfigService: TableConfigService, private langService: LanguageService, private cdr: ChangeDetectorRef) {}

  /**
   * Function to set table config
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.setTableConfig(changes.data.currentValue.reportByMachineStatusFamily);
      this.cdr.detectChanges();
    }
  }

  /**
   * Function to set table config
   *
   * @param tableData Data to fill table
   */
  private setTableConfig(tableData: any[]): void {
    const data = this.statusFamilyMapper(tableData);

    const headerParams: ITableHeaderParams = {
      data,
      translatable: false,
    };

    const datasetParams: ITableDataParams = {
      tableData: data,
      colorConfig: [{ field: 'equipo', isBold: true }],
    };
    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    const extraParams: ITableExtraParams = {
      noDataMsg: 'm034',
      disableFooter: true,
      quantityPerPage: data?.length,
    };

    this.tableConfig = { header, dataset, extraParams };
  }

  /**
   * Function to extract unique machines from reportByMachineStatusFamily
   * This replaces the old machineList property
   */
  private extractUniqueMachines(reportData: IMachineStatusFamily[]): { machineId: number; name: string }[] {
    const uniqueMachines = new Map();

    reportData?.forEach((item) => {
      if (!uniqueMachines.has(item.machineId)) {
        uniqueMachines.set(item.machineId, {
          machineId: item.machineId,
          name: item.machineName,
        });
      }
    });

    return Array.from(uniqueMachines.values());
  }

  /**
   * Function to map report response to status family table
   *
   * @param tableData Data to map
   */
  private statusFamilyMapper(tableData: any[]): any[] {
    const machineColumnName = this.langService.message('machine_name');

    // Extract unique machines from reportByMachineStatusFamily (replaces old machineList)
    const uniqueMachines = this.extractUniqueMachines(this.data.reportByMachineStatusFamily);

    const mappedStatusFamily = uniqueMachines?.map((machine) => {
      const obj = {};
      const machineModelArray = tableData.filter((model) => machine.name === model.machineName);
      Object.assign(obj, { [machineColumnName]: machine.name });

      for (const machModel of machineModelArray) {
        Object.assign(obj, { [machModel.statusFamilyName]: `${machModel.percStatus}%` });
      }

      return obj;
    });

    return mappedStatusFamily;
  }

  /**
   * On destroy component
   */
  public ngOnDestroy(): void {
    if (this.subSource) {
      this.subSource.unsubscribe();
    }
  }
}
